import React from 'react';
import { createComponent } from '@lit-labs/react';

import Dsy from './dsyui';

const LitComp = Dsy.components.DsyRow;

export const DsyRow = createComponent(
  React,
  'dsy-row',
  LitComp,
  {},
);

export default DsyRow;
